import { configureStore } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
import rootReducer from './rootReducers';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
      thunk: {
        extraArgument: {},
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
